<template>
    <div class="form-page">
        <my-form
        v-model="form"
        readonly
        table
        label-width="160px"
        @cancle="cancleHandler"
        >

            <el-form-item
            class="table-full-row"
            label="邀请书名称"
            >
                {{form.yqsname}}
            </el-form-item>

            <el-form-item
            label="招标项目名称"
            >
                {{form.zbproname}}
            </el-form-item>

            <el-form-item
            label="项目编码"
            >
                {{form.zbprocode}}
            </el-form-item>

            <el-form-item
            label="标段名称"
            >
                {{form.bdname}}
            </el-form-item>

            <el-form-item
            label="标段编码"
            >
                {{form.bdcode}}
            </el-form-item>

            <el-form-item
            label="文件获取时间"
            >
                {{form.wjhqtime}}
            </el-form-item>

            <el-form-item
            label="文件获取方法/平台地址"
            >
                {{form.wjhqff}}
            </el-form-item>

            <el-form-item
            label="文件递交截止时间"
            >
                {{form.wjdjjztime}}
            </el-form-item>

            <el-form-item
            label="文件递交方法/平台地址"
            >
                {{form.wjdjff}}
            </el-form-item>

            <el-form-item
            label="回函截止时间"
            >
                {{form.hhjztime}}
            </el-form-item>

            <el-form-item
            label="投标资格"
            >
                {{form.tbzg}}
            </el-form-item>

            <el-form-item
            class="table-full-row"
            label="公告内容" 
            >
                <ueditor v-model="form.ggcontent" readonly></ueditor>
            </el-form-item>
        

            <el-form-item
            label="附件"
            class="table-full-row"
            >
                <my-upload
                readonly
                :file-guid="form.fileguid"
                ></my-upload>
            </el-form-item>
        </my-form>

        <my-table :data="hflist">
            <el-table-column label="邀请单位名称" prop="YQDWCNNAME"></el-table-column>
            <el-table-column label="回复内容" prop="YQDWHFCONTENT">
                <template slot-scope="scope">
                    <ueditor v-model="scope.row.YQDWHFCONTENT" readonly></ueditor>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <my-tag v-if="scope.row.YQDWHFBJ === '0'" type="primart">未处理</my-tag>
                    <my-tag v-if="scope.row.YQDWHFBJ === '1'" type="success">接受邀请</my-tag>
                    <my-tag v-if="scope.row.YQDWHFBJ === '2'" type="danger">拒绝邀请</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="回复时间" prop="YQDWHFTIME">
                <template slot-scope="scope">
                    {{timePattern(scope.row.YQDWHFTIME) || '-'}}
                </template>
            </el-table-column>
        </my-table>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { },
    data: () => ({
        form: {},
        isXt:'',
        hflist: []
    }),
    methods: {

    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/FangAn/TbYqs/detail.json`, this.detailExtra, data => {
            var form = data.model;
            this.form = form;
            this.isXt = this.getQuery('isXt')
            this.jspDataInit(data, ['hflist']);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
